import 'src/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import Providers from './Providers';

// Pages
import { Dashboard } from 'src/pages/dashboard/dashboard';
import { OrderDetails } from 'src/pages/orders/orderDetails';
import { Login } from 'src/pages/login/login';
import { Members } from 'src/pages/members/members';
import { ComingSoon } from 'src/pages/comingSoon/comingSoon';
import Profile from 'src/pages/profile/profile';
import { Review } from 'src/pages/review/review';
import { Vehicles } from './pages/vehicles/vehicles';
import Reports from './pages/reports/reports';
import { TransporterTrailer } from './pages/transporterTrailer/transporterTrailer';
import { Register } from './pages/register/register';
import { Drivers } from './pages/drivers/drivers';
import { Escorts } from './pages/escorts/escorts';
import ApprovalOrders from './pages/approver/approvalOrders';
import { Employees } from './pages/employees/employees';
import OrdersPage from './pages/orders';
import { Inventory } from './pages/inventory/inventory';
import PrivacyPolicyPage from './pages/privacy-policy/page';

function App() {
  return (
    <Providers>
      <Routes>
        {/* Redirect to login */}
        <Route path="/" element={<Navigate replace to="/login" />} />

        {/* Auth Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

        <Route path="/register" element={<Register />} />
        <Route path="/review" element={<Review />} />
        <Route
          path="/orders"
          element={
            <Layout>
              <OrdersPage />
            </Layout>
          }
        />
        {/* <Route
          path="/shipper-orders"
          element={
            <Layout>
              <ShipperOrders />
            </Layout>
          }
        />
        <Route
          path="/orders"
          element={
            <Layout>
              <EnforcementOrders />
            </Layout>
          }
        /> */}
        <Route
          path="/orders/:id"
          element={
            <Layout showNavbar={false}>
              <OrderDetails />
            </Layout>
          }
        />
        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/vendors"
          element={
            <Layout>
              <ComingSoon />
            </Layout>
          }
        />
        <Route
          path="/employees"
          element={
            <Layout>
              <Employees />
            </Layout>
          }
        />
        <Route
          path="/drivers"
          element={
            <Layout>
              <Drivers />
            </Layout>
          }
        />
        <Route
          path="/escorts"
          element={
            <Layout>
              <Escorts />
            </Layout>
          }
        />
        <Route
          path="/reports"
          element={
            <Layout>
              <Reports />
            </Layout>
          }
        />
        <Route
          path="/members"
          element={
            <Layout>
              <Members />
            </Layout>
          }
        />
        <Route
          path="/profile"
          element={
            <Layout>
              <Profile />
            </Layout>
          }
        />
        {/* <Route
          path="/shipper-orders"
          element={
            <Layout>
              <ShipperOrders />
            </Layout>
          }
        /> */}
        <Route
          path="/shipper-inventory"
          element={
            <Layout>
              <ComingSoon />
            </Layout>
          }
        />
        <Route
          path="/vehicles"
          element={
            <Layout>
              <Vehicles />
            </Layout>
          }
        />
        <Route
          path="/transporter-trailers"
          element={
            <Layout>
              <TransporterTrailer />
            </Layout>
          }
        />
        <Route
          path="/orders-approval"
          element={
            <Layout>
              <ApprovalOrders />
            </Layout>
          }
        />
        <Route
          path="/inventory"
          element={
            <Layout>
              <Inventory />
            </Layout>
          }
        />
        {/* ... other routes ... */}
      </Routes>
    </Providers>
  );
}

export default App;
